import { createActions } from 'redux-actions';
import { push } from 'react-router-redux';
import Schemas from 'schemas';
import { normalize } from 'normalizr';
import { request } from '../../services';
import {
  requireAllFields,
  isEmpty,
} from '../../utils';
import { navigateBack } from 'actionCreators';
import { getStoreFilters } from '../../reducers';
import qs from 'qs';

const {
  storeListRequest,
  storeListSuccess,
  storeListFailure,
} = createActions({
  STORE_LIST_SUCCESS: json => normalize(json, { stores: Schemas.STORE_ARRAY }),
}, 'STORE_LIST_REQUEST', 'STORE_LIST_FAILURE');

export function requestAllStores() {
  return (dispatch, getState) => {
    const filters = getStoreFilters(getState());
    const filterParams = qs.stringify(filters);
    dispatch(storeListRequest());
    return request(`stores?${filterParams}`)
      .then(({ json }) => dispatch(storeListSuccess(json)))
      .catch(error => dispatch(storeListFailure(error)));
  };
}

const {
  storeResourceRequest,
  storeResourceSuccess,
  storeResourceFailure,
} = createActions({
  STORE_RESOURCE_REQUEST: id => ({ id }),
  STORE_RESOURCE_SUCCESS: json => normalize(json, Schemas.STORE),
}, 'STORE_RESOURCE_FAILURE');

export function requestStore(id) {
  return (dispatch) => {
    dispatch(storeResourceRequest(id));
    return request(`stores/${id}`)
      .then(({ json }) => dispatch(storeResourceSuccess(json)))
      .catch(error => dispatch(storeResourceFailure(error)));
  };
}

function validateNewStore(store) {
  return requireAllFields(store, []);
}

function validationFailure(errors) {
  return { type: 'STORE_RESOURCE_SYNC_VALIDATION_FAILURE', payload: { errors }, error: true };
}

const {
  storeResourceCreateRequest,
  storeResourceCreateSuccess,
  storeResourceCreateFailure,
} = createActions({
  STORE_RESOURCE_CREATE_SUCCESS: json => normalize(json, Schemas.STORE),
}, 'STORE_RESOURCE_CREATE_REQUEST', 'STORE_RESOURCE_CREATE_FAILURE');

export function createStore(store, onSuccess) {
  return (dispatch) => {
    const syncErrors = validateNewStore(store);
    if (!isEmpty(syncErrors)) {
      dispatch(validationFailure(syncErrors));
      return;
    }

    dispatch(storeResourceCreateRequest());
    request('stores/', {
      method: 'POST',
      body: { store },
    })
      .then(({ json }) => {
        onSuccess(store.name, store.number);
        dispatch(storeResourceCreateSuccess(json));
        dispatch(push('/stores'));
      },
      (error) => {
        dispatch(storeResourceCreateFailure(error));
      });
  };
}


const {
  storeResourceUpdateRequest,
  storeResourceUpdateSuccess,
  storeResourceUpdateFailure,
} = createActions({
  STORE_RESOURCE_UPDATE_SUCCESS: json => normalize(json, Schemas.STORE),
}, 'STORE_RESOURCE_UPDATE_REQUEST', 'STORE_RESOURCE_UPDATE_FAILURE');

export function updateStore(store, onSuccess) {
  return (dispatch) => {
    dispatch(storeResourceUpdateRequest());
    request(`stores/${store.id}`, {
      method: 'PUT',
      body: { store },
    })
      .then(({ json }) => {
        onSuccess();
        dispatch(storeResourceUpdateSuccess(json));
        dispatch(navigateBack());
      },
      (error) => {
        dispatch(storeResourceUpdateFailure(error));
      });
  };
}

export function resetStoreFilters() {
  return dispatch => (
    Promise.all([
      dispatch({ type: 'STORE_RESET_FILTERS' }),
      dispatch(requestAllStores()),
    ])
  );
}

export function setStoreFilters(filters) {
  return dispatch => (
    Promise.all([
      dispatch({ type: 'STORE_SET_FILTER', payload: filters }),
      dispatch(requestAllStores()),
    ])
  );
}

function fetchIfiPriorityData(storeId, { path, actionPrefix, mapPayload }) {
  return (dispatch, getState) => {
    const store = getState().stores.byId[storeId];
    if (!store || store.vendor !== 'IFI') {
      return Promise.resolve();
    }
    dispatch({ type: `${actionPrefix}_REQUEST` });
    return request(`stores/${storeId}/${path}`)
      .then(({ json }) => {
        dispatch({ type: `${actionPrefix}_SUCCESS`, payload: mapPayload(json) });
      })
      .catch(() => {
        dispatch({ type: `${actionPrefix}_FAILURE` });
      });
  };
}

export function fetchInstallersForPrioritization(storeId) {
  return fetchIfiPriorityData(storeId, {
    path: 'installer_priority',
    actionPrefix: 'STORE_INSTALLER_PRIORITIZATION',
    mapPayload: json => ({
      installersBySurfaceType: json.installers_by_surface_type || {},
      surfaceTypes: json.surface_types || [],
    }),
  });
}

export function resetInstallerPrioritization() {
  return { type: 'STORE_INSTALLER_PRIORITIZATION_RESET' };
}

export function fetchCandidatesForMeasurePrioritization(storeId) {
  return fetchIfiPriorityData(storeId, {
    path: 'measure_priority',
    actionPrefix: 'STORE_MEASURE_PRIORITIZATION',
    mapPayload: json => ({
      candidatesBySurfaceType: json.candidates_by_surface_type || {},
      surfaceTypes: json.surface_types || [],
    }),
  });
}

export function resetMeasurePrioritization() {
  return { type: 'STORE_MEASURE_PRIORITIZATION_RESET' };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/stores.js